import { Component, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';
import { FieldValueInterface } from '@vendasta/crm';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { switchMap } from 'rxjs/operators';
import { StandardIds, SystemFieldIds } from '../../../shared-services';
import { of } from 'rxjs';
import { ScoreService } from '../../../shared-services/score.service';

const NO_VALUE_FOR_SCORE = '<NO_VALUE_FOR_SCORE>';

@Component({
  templateUrl: './score.component.html',
  standalone: true,
  styleUrls: ['../shared.scss'],
  imports: [CommonModule, BlankValueComponent],
  providers: [ScoreService],
})
export class LeadScoreCellComponent extends CustomCellComponent {
  NO_VALUE_FOR_SCORE = NO_VALUE_FOR_SCORE;
  private fieldValues = signal<FieldValueInterface[]>([]);
  protected score: WritableSignal<number | '<NO_VALUE_FOR_SCORE>' | null> = signal(null);

  set value(newValues: FieldValueInterface[]) {
    this.fieldValues.set(newValues);
  }

  constructor(private readonly scoreService: ScoreService) {
    super();
    toObservable(this.fieldValues)
      .pipe(
        switchMap((fieldValues) => {
          const companyId = fieldValues.find(
            (fieldValue) => fieldValue?.fieldId === SystemFieldIds.CompanyID,
          )?.stringValue;
          const isScoreSet: boolean =
            fieldValues.find((fieldValue) => fieldValue?.fieldId === StandardIds.CompanyLeadScore)?.floatValue !==
            undefined;
          if (!companyId || !isScoreSet) {
            return of(null);
          }
          return this.scoreService.getScoreForTableRow$(companyId, StandardIds.CompanyLeadScore);
        }),
        takeUntilDestroyed(),
      )
      .subscribe((result) => {
        if (!result) {
          this.score.set(NO_VALUE_FOR_SCORE);
          return;
        }

        this.score.set(result);
      });
  }
}
